import { render } from "./LogoMain.vue?vue&type=template&id=2ee1ce9e"
const script = {}

import "./LogoMain.vue?vue&type=style&index=0&id=2ee1ce9e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__